<template>
  <div class="autoMatic_box">
<!--    <transition name="scale-fade">-->
      <div :class="['box_center',{ 'animate-popup': isInputValshow }]" ref="centerBox" v-if="isInputValshow">
        <div class="box_header">
          <div>
            我的提示词
          </div>
        </div>
        <div :class="['boxBody','show']">
          <div class="box_body">
            <div class="font_title">
              <div class="china_title" style="margin-bottom:14px ">
                {{ incan_list[0].zh }}
              </div>
            </div>
            <div class="box_footer">
              <div class="foot_btn1" @click="deactivateAll('operate1',0)">
                继续使用<img src="./img/icon_img36.png" alt=" "/>
              </div>
            </div>
          </div>
          <div class="system_box">
            <div>
              系统优化提示词
            </div>
            <div>
              <span>建议使用下方提示词，绘图质量更高。且下方提示词可修改。</span>
            </div>
          </div>
          <div class="box_body" v-if="index!=0" v-for="(item, index) in incan_list">
            <div v-if="!incan_load">
              <!--            <div v-if="false">-->
              <div class="font_title">
                <div class="china_title cn_inp" v-if="!item.more" @click="activateEdit(index)">
                  {{ item.zh }}
                </div>
                <div class="text_inp">
              <textarea ref="textareaRefs"
                        v-model="item.zh" @blur="deactivateAll"
                        v-show="item.more" rows="3"></textarea>
                </div>
                <div class="english_title">
                  {{ item.en }}
                </div>
              </div>
              <div class="box_footer">
                <div :class="['foot_btn3',index==1?'btn3_1':'btn3_2']">
                  {{ index == 1 ? '基础版' : '进阶版' }}
                </div>
                <div class="foot_btn2" @click="deactivateAll('operate2',index)">
                  使用它<img src="./img/icon_img36.png" alt=" "/>
                </div>
              </div>
            </div>
            <div v-else class="load_gif">
              <!--            <div class="load_gif">-->
              <img src="./img/AipromptWords.gif" alt="">
              <span>
              系统正在为您优化......{{ percentage }}%
            </span>
            </div>

            <div class="xuxian" v-if="index==1"></div>
          </div>
        </div>
      </div>
    <!--    <div class="autoMatic_box">-->
    <!--    <div class="box_center" v-loading="incan_load">-->
<!--    </transition>-->
  </div>
</template>
<script type="text/ecmascript-6">

export default {
  data() {
    return {

      incan_load: false, //
      incan_list: [
        {zh: '', en: '', more: false,},
        {zh: '', en: '', more: false,},
        {zh: '', en: '', more: false,},
      ], // 优化咒语列表
      textareaRefs: [],
      percentage: 1,  // 初始1%
      remainingTime: 10,
      interval: null,
      time: null,
    }
  },
  computed: {
    isInputValshow() {
      return this.$store.state.isInputValshow;
    },
    isInputtype() {
      return this.$store.state.isInputtype;
    },
    isInputVal() {
      return this.$store.state.isInputVal;
    },
  },
  created() {
    this.deactivateAll('post')
  },
  methods: {
    show(type) {
      if (type == true) {

        this.deactivateAll('post')
      } else {

        this.incan_list = [
          {zh: '', en: '', more: false,},
          {zh: '', en: '', more: false,},
          {zh: '', en: '', more: false,},
        ]
      }

    },
    activateEdit(index) {
      // 先关闭所有编辑框
      // 打开当前项的编辑状态
      console.log('index', index)
      this.incan_list.forEach((item, i) => {
        if (index == i) {
          console.log('true')
          item.more = true
          this.$nextTick(() => {
            this.$refs.textareaRefs[index - 1].focus();
          });
        } else {
          console.log('false')
          item.more = false
        }
      });
      // 等待DOM更新后聚焦
      console.log('textareaRefs', this.$refs.textareaRefs)

    },
    deactivateAll(type, index) {
      if (type === 'operate1' || type === 'operate2') {
        this.$store.commit('setisInputVal',  this.incan_list[index].zh.trim())
        this.$store.commit('setisInputValshow', false)
      } else if (type === 'post') {
        this.incan_list = [
          {zh: this.isInputVal, en: '', more: false},
          {zh: '', en: '', more: false},
          {zh: '', en: '', more: false}
        ];

        this.incan_load = true
        this.opentimer()
        console.log(1111111111)
        this.$http.post('/front/aivideo/prompt/',
            {question: this.isInputVal, type: this.isInputtype,}).then((res) => {
          this.incan_load = false
          if (res.status == 200) {
            this.incan_list = [
              {zh: this.isInputVal, en: '', more: false},
              {zh: res.data.higt1.zh, en: res.data.higt1.en, more: false},
              {zh: res.data.higt2.zh, en: res.data.higt2.en, more: false}
            ];
            console.log(this.incan_list)
            this.stopTimer()
            this.percentage = 0
          } else {
            console.log('失败')
            this.$message.error("你提交的内容涉及敏感信息,请修改后重新提交！")
            this.incan_load = false
            this.$store.commit('setisInputtype', '')
            this.$store.commit('setisInputValshow', false)
          }
        }).catch((err) => {
          console.log('失败err', err)
          this.$message.error(err.message)
          this.$store.commit('setisInputtype', '')
          this.$store.commit('setisInputValshow', false)
          this.incan_load = false

        })
      } else {
        this.incan_list.forEach((e, i) => {
          e.more = false
        });
      }
      this.percentage=1
    },
    opentimer() {
      // 更新剩余时间
      this.interval = setInterval(() => {
        this.remainingTime--;
        if (this.remainingTime <= 0 && this.percentage >= 99) {
          this.stopTimer()
        }
      }, 1000);

      // 更新随机百分比
      this.timer = setInterval(() => {
        this.percentage += Math.floor(Math.random() * 5) + 1;
        if (this.percentage >= 99) {
          this.percentage = 99
        }
      }, 500); // 每300毫秒更新一次随机值
    },
    stopTimer() {
      clearInterval(this.timer);
      clearInterval(this.interval);
    },

  },
  watch: {
    '$store.state.isInputValshow'(newVal) {

    },
  },
};


</script>
<style rel="stylesheet/scss" lang="scss" scoped>
// 自动优化
.autoMatic_box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #fff;
  font-weight: 400;
  line-height: 1.4;
  z-index: 99999999;

  .box_center {
    width: 95%;
    height: 90%;
    border-radius: 10px;
    border: 2px solid #5865f2;
    background-color: #000;
    overflow: hidden;
    &.animate-popup {
      animation: scaleIn 0.5s ease-out;
    }

    .box_header {
      background-color: #5865f2;
      padding: 10px 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 700;
    }



    .boxBody {
      height: calc(100% - 40px);
      overflow: auto;

      .box_body {
        font-size: 14px;
        padding: 0 14px;
        margin: 14px 0;

        .load_gif {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;

          img {
            width: 150px;
          }

          span {
            margin-bottom: 10px;
          }
        }

        .font_title {
          line-height: 1.2;

          .china_title {
            //display: -webkit-box;
            //-webkit-line-clamp: 3;  /* 限制为3行 */
            //-webkit-box-orient: vertical;
            //overflow: hidden;
            //text-overflow: ellipsis;
            line-height: 1.6;
            color: #aaa;

            &.cn_inp {
              cursor: pointer;
            }
          }

          .english_title {
            //display: -webkit-box;
            //-webkit-line-clamp: 3;  /* 限制为3行 */
            //-webkit-box-orient: vertical;
            //overflow: hidden;
            //text-overflow: ellipsis;
            line-height: 1.4;
            word-break: break-all;
            color: #997a48;
            margin: 14px 0;
          }

          .text_inp {
            textarea {
              width: 100%;
              padding: 5px 8px;
              border-radius: 4px;
              border: 2px solid #5865f2;
            }
          }
        }

        .box_footer {
          display: flex;
          justify-content: flex-end;

          .foot_btn1, .foot_btn2, .foot_btn3 {
            cursor: pointer;
            color: #fff;
            font-size: 14px;
            width: 110px;
            padding: 10px 14px;
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;

            img {
              width: 12px;
              height: 12px;
              margin-left: 4px;
            }
          }

          .foot_btn1 {
            background-color: #5865f2;

          }

          .foot_btn2 {
            background-color: #997a48;
          }

          .foot_btn3 {
            width: 95px;
            margin-right: 10px;
            background-color: #333333;
            cursor: auto;

            &.btn3_1 {
              color: #999;

            }

            &.btn3_2 {
              color: #997a48;
            }
          }

        }

        .xuxian {
          width: 100%;
          border-top: 1px dashed #666666;
          margin-top: 14px;
        }
      }
    }

    .system_box {
      background-color: #333333;
      padding: 10px 10px;
      color: white;
      font-size: 14px;
      font-weight: 700;
      display: flex;
      align-items: flex-start;
      flex-direction: column;

      span {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
      }
    }
  }


}

@keyframes scaleIn {
  0% {
    transform: translateY(1000px);
    //opacity: 0;
  }
  100% {
    transform: translateY(0);
    //opacity: 1;
  }
}

///* 进入和离开动画 */
//.scale-fade-enter-active {
//  animation: scaleIn 3s ease-out;
//}
//.scale-fade-leave-active {
//  animation: scaleIn 3s ease-out reverse;
//}
//
///* 关键帧动画（复用你已有的 keyframes） */
//@keyframes scaleIn {
//  0% {
//    transform: translateY(20px);
//    opacity: 0;
//  }
//  100% {
//    transform: translateY(0);
//    opacity: 1;
//  }
//}
</style>

